import { render, staticRenderFns } from "./SiInputAutocomplete.vue?vue&type=template&id=27b33df6&scoped=true&lang=html&"
import script from "./SiInputAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SiInputAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b33df6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
